import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';

@Component({
  selector: 'app-bank-info',
  templateUrl: './bank-info.component.html',
  styleUrl: './bank-info.component.scss'
})
export class BankInfoComponent {
  bankForm!: FormGroup;

  constructor(private fb: FormBuilder, private spinner: NgxSpinnerService, private finzyService: FinzyService, private router: Router) { }

  ngOnInit(): void {
    this.bankForm = this.fb.group({
      accountNumber: [
        '',
        [Validators.required, Validators.pattern(/^[0-9]{9,18}$/)]
      ],
      accountType: ['', Validators.required],
      accountHolderName: ['', Validators.required],
      ifscCode: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/i) // Standard IFSC format
        ]
      ]
    });
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  get m() {
    return this.bankForm.controls;
  }

  async onSubmit() {
    if (this.bankForm.invalid) {
      this.bankForm.markAllAsTouched();
      return;
    }

    const formValue = this.bankForm.value;

    try {
      var res = await lastValueFrom(this.finzyService.UpdateBankInfo({ BankInfo: formValue }));
      if (res['data']) {
        this.router.navigateByUrl('/assist-journey/f/vkyc');
      }
    }
    catch (err) {
      console.log(err);
    }


    // Example API call
    // this.http.post('https://yourapi.com/api/Bank/SaveBankDetails', formValue)
    //   .subscribe(res => console.log('Success:', res));
  }
}
